import { Controller } from 'stimulus'
import SignaturePad from 'signature_pad/dist/signature_pad'

export default class extends Controller {
  static targets = ['canvas', 'input']
  static values = { file: String }

  connect() {
    this.initSignaturePad()
  }

  initSignaturePad() {
    const signature = new SignaturePad(this.canvasTarget)

    signature.addEventListener('endStroke', () => {
      this.inputTarget.value = signature.toDataURL()
    })
  }
}
